<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>
                巡检任务
                <small>巡检任务</small>
            </h1>
            <ol class="breadcrumb">
                <li>
                    <a href="#">
                        <i class="fa fa-dashboard"></i> 巡检任务
                    </a>
                </li>
                <li class="active">巡检任务</li>
            </ol>
        </section>
        <!-- Main content -->
        <section class="content">
            <div class="row col-sm-12">
                <div id="atptoolbar">
                    <button class="btn btn-warning" type="button" id="sys_add" @click="addtask">
                        <i class="fa fa-pencil"></i>&nbsp;添加巡检任务
                    </button>
                    <button class="btn btn-warning" type="button" id="sys_dispatch" @click="dispatch">
                        <i class="fa fa-pencil"></i>&nbsp;派单
                    </button>
                    <button class="btn btn-primary" type="button" id="sys_del" @click="completetask">
                        <i class="fa fa-pencil"></i>&nbsp;完成巡检
                    </button>
                    <button class="btn btn-danger" type="button" id="sys_del" @click="deltask">
                        <i class="fa fa-eraser"></i>&nbsp;删除巡检任务
                    </button>
                </div>
                <table id="checktask_atptable"></table>
            </div>
        </section>
        <!-- /.content -->
        <v-addammetertask :info-taskid="task_id" ref="addchecktask"></v-addammetertask>
        <v-dispatch :info-taskid="task_id" ref="dispatch"></v-dispatch>
    </div>
</template>

<script>
  import addammetertask from './addchecktask'
  import dispatch from './dispatch'

  export default {
    name: '',
    data () {
      return {
        task_id: '' // 任务id
      }
    },
    components: {
      'v-addammetertask': addammetertask,
      'v-dispatch': dispatch
    },
    mounted: function () {
      // 获取所有的巡检任务
      var self = this
      $('#checktask_atptable').bootstrapTable({
        url: self.global.apiHost + 'tasks/',
        method: 'get', //请求方式（*）
        ajaxOptions: {
          headers: {
            'content-type': 'application/json', // 默认值
            Authorization: 'Bearer ' + localStorage.getItem('access_token')
          }
        },
        toolbar: '#atptoolbar', //工具按钮用哪个容器
        height: $(window).height() * 0.86,
        striped: true, //是否显示行间隔色
        cache: false, //是否使用缓存，默认为true，所以一般情况下需要设置一下这个属性（*）
        pagination: true, //是否显示分页（*）
        iconSize: 'outline',
        sortable: true, //是否启用排序
        sortName: 'stst_atpid',
        sortOrder: 'DESC', //排序方式
        queryParams: self.queryParams, //传递参数（*）
        sidePagination: 'server', //分页方式：client客户端分页，server服务端分页（*）
        pageNumber: 1, //初始化加载第一页，默认第一页
        pageSize: 10, //每页的记录行数（*）
        pageList: [10], //可供选择的每页的行数（*）
        search: true, //是否显示表格搜索，此搜索是客户端搜索，不会进服务端，所以，个人感觉意义不大
        showColumns: true, //是否显示所有的列
        showRefresh: true, //是否显示刷新按钮
        minimumCountColumns: 2, //最少允许的列数
        clickToSelect: true, //是否启用点击选中行
        singleSelect: true, // 是否启用单选
        uniqueId: 'id', //每一行的唯一标识，一般为主键列
        responseHandler: function (res) {
          console.log('-------', res)
          return {
            total: res.total, //总页数
            rows: res.rows //数据
          }
        },
        columns: [
          [
            { checkbox: true },
            {
              title: '序号',
              width: 40,
              formatter: function (value, row, index) {
                return index + 1
              }
            },
            {
              title: '基站名称',
              width: 40,
              field: 'stst_commname'
            },
            {
              title: '运营商',
              width: 40,
              field: 'stst_comm'
            },
            {
              title: '任务批号',
              width: 40,
              field: 'batch_no'
            },
            {
              title: '任务来源',
              width: 40,
              field: 'source',
              formatter: function (value, row, index) {
                if (value == 1) {
                  return '小程序'
                } else {
                  return '后台'
                }
              }
            },
            {
              title: '任务说明',
              width: 40,
              field: 'description'
            }
          ]
        ]
      })
    },
    methods: {
      queryParams: function (param) {
        param.org_id = JSON.parse(localStorage.getItem('companyInfo')).id
        param.type = 2
        param.per_page = param.limit
        param.page = param.offset / param.limit + 1
        return param
      },
      // 打开添加巡检任务页面
      addtask: function () {
        var self = this
        $('#sys_addchecktask_modal').modal('show')
        setTimeout(function () {
          self.$refs.addchecktask.initFunc() // 调用子组件函数
        }, 1000)
      },
      // 派单
      dispatch: function () {
        var self = this
        var tablerow = $('#checktask_atptable').bootstrapTable('getSelections')
        if (tablerow.length == 1) {
          var _task_id = tablerow[0].id
          self.task_id = _task_id
          $('#sys_dispatch_modal').modal('show')
          setTimeout(function () {
            self.$refs.dispatch.initFunc() // 调用子组件函数
          }, 1000)
        } else {
          alert('必须只选择一项')
        }
      },
      // 完成巡检
      completetask: function () {
        var self = this
        var tablerow = $('#checktask_atptable').bootstrapTable('getSelections')
        if (tablerow.length == 1) {
          self.global.axiosPut(
            self,
            'tasks/' + self.infoTaskid + '/',
            { status: 50 },
            function (res) {
              console.log('完成巡检', res)
              if (res.status == 'status') {
                alert('提交成功')
              } else {
                alert('提交失败')
              }
              $('#checktask_atptable').bootstrapTable('refresh')
            },
            function () {
              alert('提交失败')
            }
          )
        } else {
          alert('必须只选择一项')
        }
      },
      //删除巡检任务
      deltask: function () {
        var self = this
        var tablerow = $('#checktask_atptable').bootstrapTable('getSelections')
        if (tablerow.length == 1) {
          // confirm
          var r = confirm('确定删除该查表任务?') // 询问框里的文字描述
          if (r == true) {
            var _task_id = tablerow[0].id
            self.global.axiosDelete(
              self,
              'tasks/' + _task_id + '/',
              function (res) {
                if (res.status == 'success') {
                  alert('删除成功')
                } else {
                  alert('操作失败')
                }
                $('#checktask_atptable').bootstrapTable('refresh')
              },
              function (res) {
                alert('操作失败')
              }
            )
          } else {
            console.log('取消')
          }
        } else {
          alert('必须只选择一项')
        }
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/checktask/checktask.vue